import React, { ReactNode } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "moment/locale/hu";
import {
  MyLeaveCalendarEventArrow,
  MyLeaveCalendarEventTooltip,
} from "my-leave/components";

interface MyLeaveCalendarEventWrapperProps {
  event: any; // TODO: replace 'any' with the actual event type
  continuesPrior?: boolean;
  continuesAfter?: boolean;
  children?: ReactNode;
}

export const MyLeaveCalendarEventWrapper: React.FC<
  MyLeaveCalendarEventWrapperProps
> = (props) => {
  const theme = useTheme();
  const { event, continuesPrior, continuesAfter, children } = props;

  return (
    <Tooltip
      arrow
      title={<MyLeaveCalendarEventTooltip event={event} />}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: theme.palette.darkBase.main,
            borderRadius: "8px",
          },
        },
        arrow: {
          sx: {
            color: theme.palette.darkBase.main,
          },
        },
      }}
    >
      <div
        className="custom-event-wrapper"
        style={{ display: "flex", flexDirection: "row" }}
      >
        {continuesPrior && (
          <MyLeaveCalendarEventArrow event={event} continues="prior" />
        )}
        {children}
        {continuesAfter && (
          <MyLeaveCalendarEventArrow event={event} continues="after" />
        )}
      </div>
    </Tooltip>
  );
};

export default MyLeaveCalendarEventWrapper;
